import Vue from 'vue';
import axios from 'axios';
import router from '../router'

// Creamos una instancia de axios para que se puedan compartir la misma configuración en toda la aplicación

const DEV_API='http://alipa.test/api/';
const PROD_API='https://api.alipa.info/api/';


const apiUrl=process.env.NODE_ENV == 'development'?DEV_API:PROD_API;

const api = axios.create({
  baseURL: apiUrl,
});


// Interceptamos todas las solicitudes realizadas por axios
api.interceptors.request.use((config) => {
  
    
  // Obtenemos el token de acceso almacenado en el almacenamiento local (localStorage)
  const accessToken = localStorage.getItem('token');
  config.headers.Authorization = `Bearer ${accessToken}`;
  

  return config;
});




api.interceptors.response.use(
  response => {
    
    const token=response.data.token;
    if(token){
    
      if(token){
        localStorage.setItem('token',token);
      }else{
        router.push('/acceso');
      }


    }else{
      
      router.push('/acceso');
    }

    return response;
  },
  error => {
    
    router.push('/acceso');
    return Promise.reject(error);
  }
);



export default api;
